import React from 'react';
import { Paper, Typography } from '@material-ui/core';

const VideoDetail = ({ video }) =>{
    if(!video) return <div>Search ... </div>
    
    const videoSrc = `https://www.youtube.com/embed/${video.id.videoId}`
    return(
        <div style={{height:"27%"}}>
         <Paper elevation={6} style={{height: '100%'}}>
             <iframe width="100%" height="100%" src={videoSrc} frameborder="0" allowfullscreen></iframe>
         </Paper>

         <Paper elevation={6} style={{padding: '15px'}}>
             <Typography variant="h4" style={{ fontSize: '20px'}}>
                 {video.snippet.title} - {video.snippet.channelTitle}
             </Typography>
             <Typography variant="subtitle1">
                  {video.snippet.channelTitle}
             </Typography>
             <Typography variant="subtitle2">
                  {video.snippet.description}
             </Typography>
         </Paper>
        </div>
    )
}

export default VideoDetail;